import { React, useContext, useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import GoBack from "../../components/goBack";
import { useNavigate, useParams } from "react-router-dom";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import AuthContext from "../../components/shared/AuthContext";
import useAuthHelper from "../../helpers/AuthHelper";
import {
  COMMERCIAL_ROLE_ID,
  COMPTABLE_ROLE_ID,
  ALL_ACCESS_ROLE_ID,
} from "../../helpers/constants";
const UpdateMember = () => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { user } = useContext(AuthContext);
  const { onlyAdmins } = useAuthHelper();

  useEffect(() => {
    onlyAdmins();
    setWarning("");
    getOrgs();
    getMembre();
  }, []);

  //states
  const [memberInfo, setMemberInfo] = useState({});
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [permission, setPermission] = useState("");
  const [allOrgs, setAllOrgs] = useState([]);
  const [selectedNewOrgs, setSelectedNewOrgs] = useState([]);
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [warning, setWarning] = useState("");
  const [passwordIdentique, setPasswordIdentique] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [hadAddAccess, setHadAddAccess] = useState(false);
  const [hadEditAccess, setHadEditAccess] = useState(false);
  const [hadDeleteAccess, setHadDeleteAccess] = useState(false);
  const permissionIsComptabilite = useRef();
  const permissionIsCommercial = useRef();
  const allPermission = useRef();

  //get all users orgs
  const getOrgs = async () => {
    setLoaded(false);
    await jwtInterceoptor
      .get("/data/organisations")
      .then((response) => {
        if (response.data) {
          let orgs = [];
          let obj = {};

          for (let i = 0; i < response.data.data.length; i++) {
            obj = {
              value: response.data.data[i]["id"],
              label: response.data.data[i]["name"],
            };
            orgs.push(obj);
          }

          setAllOrgs(orgs);
          setLoaded(true);
        }
      })
      .catch((error) =>
        console.log("error while retrieving all users's orgs : " + error)
      );
  };
  //get all information a propos membre
  let memberId = useParams();
  console.log(memberId);
  const getMembre = () => {
    jwtInterceoptor
      .get(`data/team/list/membre/${parseInt(memberId.id)}`)
      .then((response) => {
        if (response.data.status) {
          console.log("member data: ", response.data.data);
          setMemberInfo(response.data.data[0]);
          setSelectedOrgs(response.data.data[0].orgs.split(","));
          setEmail(response.data.data[0].email);
          setPhone(response.data.data[0].phone);
          setName(response.data.data[0].name);
          setLastName(response.data.data[0].nick_name);
          setHadAddAccess(response.data.data[0].access.had_add_access);
          setHadEditAccess(response.data.data[0].access.had_edit_access);
          setHadDeleteAccess(response.data.data[0].access.had_delete_access);
          switch (response.data.data[0].role.id) {
            case 5:
              setPermission("commercial");
              break;
            case 6:
              setPermission("comptable");
              break;
            case 2:
              setPermission("all");
              break;
            default:
              setPermission(" ");
              break;
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching member data:", error);
      });
  };

  const handleConfirmPassword = (confirmPassword) => {
    if (password === confirmPassword) {
      setWarning("");
      setPasswordIdentique(true);
    } else {
      setPasswordIdentique(false);
      setWarning(
        "Mot de passe sont pas identique, Veuillez vérifier les mots de passe saisi !"
      );
    }
  };

  const handleEyePasswordClick = (element) => {
    if (element === "input1") var input = document.getElementById("pwd1");
    else var input = document.getElementById("pwd2");

    if (input.getAttribute("type") === "password") {
      input.setAttribute("type", "text");
    } else {
      input.setAttribute("type", "password");
    }
  };

  const Save = async () => {
    let orgsString = "";

    if (
      name === "" ||
      lastName === "" ||
      email === "" ||
      phone === "" ||
      permission === "" ||
      selectedOrgs.length === 0
    ) {
      toast.error(t("Tout les champs sont obligatoire"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      let data = {};
      let test = selectedNewOrgs.length === 0 ? selectedOrgs : selectedNewOrgs;
      // orgsString = getIdsFromOrgsArray(test);
      orgsString = test.join(",");
      data = {
        name: name,
        lastName: lastName,
        email: email,
        phone: phone,
        password: password,
        permission: permission,
        orgs: orgsString,
        parent_id: user.id,
        had_add_access:hadAddAccess,
        had_edit_access:hadEditAccess,
        had_delete_access:hadDeleteAccess,
      };
      console.log("data: ", data);

      try {
        const response = await jwtInterceoptor.patch(
          `data/team/list/${parseInt(memberId.id)}`,
          data
        );

        if (response.data.status) {
          Swal.fire(
            t("Les informations du membre ont été mises à jour avec succès"),
            t(""),
            "success"
          );
          navigate("/team/list");
        } else {
          toast.error(t("Échec de la mise à jour du membre"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        console.error("Error while updating member:", error);
        toast.error(t("Erreur lors de la mise à jour du membre"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const handleCheckboxChange = (value) => {
    setPermission(value);
  };

  const getIdsFromOrgsArray = (orgs) => {
    /**
     *
     * @type {string}
     */
    let string = "";

    for (let i = 0; i < orgs.length; i++) {
      if (i === 0) string += orgs[i]["value"];
      else string += "," + orgs[i]["value"];
    }
    return string;
  };

  return (
    <>
      <ToastContainer />
      <div className="col-md-12" style={{ display: loaded ? "none" : "block" }}>
        <center>
          <div class="spinner-border text-primary me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </center>
      </div>

      <div
        className="main-container container-fluid"
        style={{ display: !loaded ? "none" : "block" }}
      >
        <>
          <GoBack route={"/team/list"} />

          <div className="page-header">
            <h1 className="page-title breadcumpsHeader">Équipe de travail</h1>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="javascript:void(0)"
                    onClick={() => navigate("/team/list")}
                  >
                    Liste des membres d'équipe
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Modifier un membre
                </li>
              </ol>
            </div>
          </div>
        </>

        <div class="row">
          <div class="col-xl-4">
            <div class="card">
              <div class="card-header">
                <div class="card-title">Authentification</div>
              </div>
              <div class="card-body">
                <div class="text-center chat-image mb-5">
                  <div class="main-chat-msg-name">
                    <a href="">
                      <h5 class="mb-1 text-dark fw-semibold">
                        {lastName.toUpperCase()} {name.toUpperCase()}
                      </h5>
                    </a>
                  </div>
                </div>
                <div class="form-group">
                  <label className="form-label">Noveau Mot de passe</label>
                  <div
                    class="wrap-input100 validate-input input-group"
                    id="Password-toggle"
                  >
                    <a
                      onClick={() => handleEyePasswordClick("input1")}
                      href="javascript:void(0)"
                      className="input-group-text bg-white text-muted"
                    >
                      <i
                        class="zmdi zmdi-eye text-muted"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <input
                      id="pwd1"
                      className="input100 form-control"
                      type="password"
                      placeholder="test123"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label className="form-label">
                    Confirmer le Noveau mot de passe
                  </label>
                  <div
                    class="wrap-input100 validate-input input-group"
                    id="Password-toggle1"
                  >
                    <a
                      onClick={() => handleEyePasswordClick("input2")}
                      href="javascript:void(0)"
                      className="input-group-text bg-white text-muted"
                    >
                      <i
                        class="zmdi zmdi-eye text-muted"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <input
                      id="pwd2"
                      className="input100 form-control"
                      type="password"
                      placeholder="test123"
                      onChange={(e) => handleConfirmPassword(e.target.value)}
                    />
                  </div>
                  <p style={{ color: "red", fontWeight: "bolder" }}>
                    {" "}
                    {warning}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-8">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Information générale</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group">
                      <label htmlFor="exampleInputname">Prénom</label>
                      <input
                        type="text"
                        name="nick_name"
                        className="form-control"
                        id="exampleInputname"
                        placeholder="prénom"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group">
                      <label htmlFor="exampleInputname1">Nom</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="exampleInputname1"
                        placeholder="Nom"
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName}
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label htmlFor="exampleInputEmail1">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    disabled
                  />
                </div>
                <div class="form-group">
                  <label htmlFor="exampleInputnumber">
                    Numéro de téléphone
                  </label>
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    id="exampleInputnumber"
                    placeholder="+212 689956325"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title">Les permissions</div>
                  </div>
                  <div class="card-body">
                    <div class="form-group mg-b-10">
                      <label className="custom-switch ps-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          checked={permission === "comptable"}
                          onChange={() => handleCheckboxChange("comptable")}
                        />
                        <span class="custom-switch-indicator me-3" />
                        <span class="custom-switch-description mg-l-10">
                          Comptabilité
                        </span>
                      </label>
                    </div>

                    <div class="form-group mg-b-10">
                      <label className="custom-switch ps-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          checked={permission === "commercial"}
                          onChange={() => handleCheckboxChange("commercial")}
                        />
                        <span class="custom-switch-indicator me-3"></span>
                        <span class="custom-switch-description mg-l-10">
                          Gestion commerciale
                        </span>
                      </label>
                    </div>

                    <div class="form-group mg-b-10">
                      <label className="custom-switch ps-0">
                        <input
                          type="checkbox"
                          name="custom-switch-checkbox"
                          className="custom-switch-input"
                          checked={permission === "all"}
                          onChange={() => handleCheckboxChange("all")}
                        />
                        <span class="custom-switch-indicator me-3"></span>
                        <span class="custom-switch-description mg-l-10">
                          Les deux
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title">Les organisations</div>
                  </div>
                  <div class="card-body">
                    <div class="form-group mg-b-10">
                      <div>
                        {allOrgs.map((org) => {
                          console.log("selected Orgs ", selectedOrgs);
                          console.log("selected new Orgs ", selectedNewOrgs);
                          return (
                            <div className="form-check form-check-inline mb-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                multiple={true}
                                name={org.value}
                                checked={
                                  selectedNewOrgs.length > 0
                                    ? selectedNewOrgs.includes(org.value)
                                    : selectedOrgs.includes(
                                        org.value.toString()
                                      )
                                }
                                value={org.value}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedNewOrgs([
                                      ...selectedNewOrgs,
                                      org.value,
                                    ]);
                                  } else {
                                    setSelectedNewOrgs(
                                      selectedNewOrgs.filter(
                                        (value) => value !== org.value
                                      )
                                    );
                                  }
                                }}
                              />
                              <label className="form-check-label ms-1">
                                {org.label}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <div class="card-title">Options de comptabilité</div>
              </div>
              <div class="card-body">
                <div class="form-group">
                  <label>Options de comptabilité :</label>
                  <br />
                  <div className="custom-switch ps-0">
                    <label className="custom-switch ps-0">
                      <input
                        type="checkbox"
                        className="custom-switch-input"
                        checked={hadAddAccess}
                        onChange={(e) => setHadAddAccess(e.target.checked)}
                      />
                      <span class="custom-switch-indicator me-3" />
                      <span class="custom-switch-description mg-l-10">
                        Ajouter
                      </span>
                    </label>
                  </div>
                  <br />
                  <div className="custom-switch ps-0">
                    <label className="custom-switch ps-0">
                      <input
                        type="checkbox"
                        className="custom-switch-input"
                        checked={hadEditAccess}
                        onChange={(e) => setHadEditAccess(e.target.checked)}
                      />
                      <span class="custom-switch-indicator me-3" />
                      <span class="custom-switch-description mg-l-10">
                        Modifier
                      </span>
                    </label>
                  </div>
                  <br />
                  <div className="custom-switch ps-0">
                    <label className="custom-switch ps-0">
                      <input
                        type="checkbox"
                        className="custom-switch-input"
                        checked={hadDeleteAccess}
                        onChange={(e) => setHadDeleteAccess(e.target.checked)}
                      />
                      <span class="custom-switch-indicator me-3" />
                      <span class="custom-switch-description mg-l-10">
                        Supprimer
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-footer">
            <div className="row">
              <div className="col-md-12">
                <button
                  disabled={isSubmit}
                  type="button"
                  className="btn btn-primary"
                  onClick={Save}
                >
                  {isSubmit ? t("Loading ...") : t("Enregistrer")}
                </button>
                <a
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="btn btn-default float-end"
                >
                  Annuler
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMember;
